// Utilitário para colorir status de agenda e mensagens (padrão visual do sistema legado)
const defaultStatusColor = {
  color: '#000000',
};

const baseStatusPalette = {
  aberta: {
    color: '#000000',
  },
  altocusto: {
    color: '#008000',
    fontWeight: 'bold',
  },
  'alto custo': {
    color: '#008000',
    fontWeight: 'bold',
  },
  reservado: {
    color: '#e60000',
    fontWeight: 'bold',
  },
  marcada: {
    color: '#000000',
    fontWeight: 'bold',
  },
  atendido: {
    color: '#0000dd',
    fontWeight: 'bold',
  },
  'em atendimento': {
    color: '#d63384',
    fontWeight: 'bold',
  },
  'em preparo': {
    color: '#8257e5',
    fontWeight: 'bold',
  },
  'em eletro': {
    color: '#a16207',
    fontWeight: 'bold',
  },
  faltou: {
    textDecoration: 'line-through',
    color: '#808000',
    fontWeight: 'bold',
  },
  'não realizou': {
    textDecoration: 'line-through',
    color: '#0dcaf0',
    fontWeight: 'bold',
  },
  cancelado: {
    textDecoration: 'line-through',
    color: '#dc3545',
    fontWeight: 'bold',
  },
  laudado: {
    color: '#15803d',
    fontWeight: 'bold',
  },
  chamado: {
    color: '#16a34a',
    fontWeight: 'bold',
  },
  faturado: {
    backgroundColor: '#ffff00',
    color: '#000000',
    fontWeight: 'bold',
  },
  solicitado: {
    backgroundColor: '#ff0000',
    color: '#80ff00',
    fontWeight: 'bold',
  },
  encaminhado: {
    backgroundColor: '#00ff00',
    color: '#004d00',
    fontWeight: 'bold',
  },
  desmarcada: {
    backgroundColor: '#0000ff',
    color: '#00ff00',
    fontWeight: 'bold',
  },
  fechada: {
    backgroundColor: '#343a40',
    color: '#fff',
    fontWeight: 'bold',
  },
  feriado: {
    backgroundColor: '#0dcaf0',
    color: '#000',
    fontWeight: 'bold',
  },
  agendada: {
    color: '#008000',
    fontWeight: 'bold',
  },
  nova: { backgroundColor: '#0d6efd', color: '#fff' },
  lida: { backgroundColor: '#e0e0e0', color: '#888' },
  resolvida: {
    backgroundColor: '#43a047',
    color: '#fff',
    fontWeight: 'bold',
  },
  pendente: {
    backgroundColor: '#fbc02d',
    color: '#fff',
    fontWeight: 'bold',
  },
  aguardando: {
    backgroundColor: '#ff9800',
    color: '#fff',
    fontWeight: 'bold',
  },
  default: defaultStatusColor,
};

export function getStatusColor(status, paletteOverrides = {}) {
  if (!status) return defaultStatusColor;

  const palette = { ...baseStatusPalette, ...paletteOverrides };
  const normalized = String(status).trim().toLowerCase();
  const compact = normalized.replace(/\s+/g, '');

  return palette[normalized] || palette[compact] || palette.default || defaultStatusColor;
}
